import { Provider } from '@angular/core';

import { ClockingUseCasesImpl } from '@app/domain/use-cases/mot/clocking/clocking.use-cases';
import { CLOCKING_USE_CASES as CLOCKING_USE_CASES } from '@app/domain/use-cases/mot/clocking/clocking.use-cases.contract';

export const clockingUseCasesProvider: Provider = {
  provide: CLOCKING_USE_CASES,
  useClass: ClockingUseCasesImpl
};
